document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".column-item ");
  const collections = document.querySelectorAll(".featured-collection");

  items.forEach((item) => {
    item.addEventListener("click", function () {
      const selector = item.getAttribute("data-selector");

      items.forEach((el) => el.classList.remove("active"));
      item.classList.add("active");


      collections.forEach((col) => {
        col.style.display = "none";
      });

      const activeCollection = document.querySelector(
        `.featured-collection[data-selector="${selector}"]`
      );
      if (activeCollection) {
        activeCollection.style.display = "block";
      }
    });
  });

});

